import { cartTypes } from "./types"

const addItem = item => {
    return {
        type: cartTypes.ADD_ITEM,
        payload: item,
    }
}

const editItem = (index, item) => {
    return {
        type: cartTypes.EDIT_ITEM,
        payload: { index, item },
    }
}

const removeItem = id => {
    return {
        type: cartTypes.REMOVE_ITEM,
        payload: id,
    }
}

const setOrderId = webOrderId => {
    return {
        type: cartTypes.SET_ORDER_ID,
        payload: webOrderId,
    }
}
const setIntegrationId = integrationId => {
    return {
        type: cartTypes.SET_INTEGRATION_ID,
        payload: integrationId,
    }
}

const clear = () => {
    return {
        type: cartTypes.CLEAR,
    }
}

export const cartActions = {
    addItem,
    editItem,
    removeItem,
    setOrderId,
    setIntegrationId,
    clear,
}